class DistributorManager {
    // Klassen-Properties
    container = null;
    distributorUrl = window.shopifyData?.distributorUrl;
    translationUrl = window.shopifyData?.translationUrl;
    continentTemplate = null;
    distributorTemplate = null;
    userLang = null;
    langKey = null;
    translations = null;

    constructor() {
        // Überprüfen, ob die Seite die richtige Klasse hat
        if (!$('.page-weltweite-vertriebspartner-content').length) {
            return;
        }

        // Class-Properties initialisieren
        this.container = document.querySelector('.page-weltweite-vertriebspartner-content');
        this.continentTemplate = document.getElementById('continent-template').content;
        this.distributorTemplate = document.getElementById('distributor-template').content;
        this.userLang = Shopify.locale;
        this.langKey = this.userLang?.toUpperCase() || 'EN';

        if (!this.container) {
            console.error('Container für Distributoren nicht gefunden.');
            return;
        }

        // Übersetzungen laden und dann die Distributoren rendern
        this.loadTranslations().then(() => {
            this.loadDistributors();
        });

        // Click-Handler hinzufügen
        this.addClickHandlers();
    }

    // Lädt die Übersetzungen aus der translation.json
    loadTranslations() {
        return fetch(this.translationUrl)
            .then(response => response.json())
            .then(data => {
                this.translations = data;
            })
            .catch(error => console.error('Error fetching/parsing the translation JSON:', error));
    }

    // Lädt die Distributor-Daten und übergibt sie an die Render-Funktion
    loadDistributors() {
        if (this.container) {
            fetch(this.distributorUrl)
                .then(response => response.json())
                .then(data => this.renderDistributors(data))
                .catch(error => console.error('Error fetching/parsing the distributor JSON:', error));
        }
    }

    // Rendert die Distributor-Daten in die HTML-Struktur
    renderDistributors(data) {
        for (let continentKey in data) {
            if (data.hasOwnProperty(continentKey)) {
                const continent = data[continentKey];

                // Kontinent-Template klonen
                let continentClone = document.importNode(this.continentTemplate, true);

                // Kontinent-Name einsetzen
                let continentNameElement = continentClone.querySelector('.continent-name');
                continentNameElement.textContent = this.translations[continentKey]?.[this.langKey] || this.translations[continentKey]?.['EN'] || continentKey.toUpperCase();

                // Distributor-Container finden
                let distributorContainer = continentClone.querySelector('.distributor-container');

                // Länder im Kontinent durchlaufen
                for (let countryCode in continent) {
                    if (continent.hasOwnProperty(countryCode)) {
                        const country = continent[countryCode];
                        let distributorClone = this.prepareDistributor(country, countryCode);
                        distributorContainer.appendChild(distributorClone);
                    }
                }

                // Kontinent in den Container einfügen
                this.container.appendChild(continentClone);
            }
        }
    }

    // Bereitet einen einzelnen Distributor-Eintrag vor
    prepareDistributor(country, countryCode) {
        let distributorClone = document.importNode(this.distributorTemplate, true);

        // Ländername aus translation.json abrufen
        let countryName = this.translations[countryCode]?.[this.langKey] || this.translations[countryCode]?.['EN'] || countryCode.toUpperCase();
        distributorClone.querySelector('.country-name').textContent = countryName;

        const addr = country.addr;
        if (addr.company) {
            distributorClone.querySelector('.company').textContent = addr.company;
        }
        if (addr.tel) {
            let telLink = distributorClone.querySelector('.tel');
            telLink.href = `tel:${addr.tel}`;
            telLink.textContent = addr.tel;

            let telName = distributorClone.querySelector('.phone_name');
            telName.textContent = this.translations["_fon"]?.[this.langKey] || this.translations["_fon"]["EN"];
            distributorClone.querySelector('.phone').style.display = 'block';
        } else {
            distributorClone.querySelector('.phone').style.display = 'none';
        }
        if (addr.email) {
            let emailLink = distributorClone.querySelector('.email');
            emailLink.href = `mailto:${addr.email}`;
            emailLink.textContent = addr.email;
        }
        if (addr.adr1) {
            distributorClone.querySelector('.adr1').textContent = addr.adr1;
        }
        if (addr.adr2) {
            distributorClone.querySelector('.adr2').textContent = addr.adr2;
        }
        if (addr.zip_city) {
            distributorClone.querySelector('.zip_city').textContent = addr.zip_city;
        }
        if (addr.link) {
            let link = distributorClone.querySelector('.link');
            link.href = addr.link;
            link.textContent = addr.link;
            if (addr.link_name) {
                link.textContent = addr.link_name;
            }
            link.target = '_blank';
            link.rel = 'noopener';
        }
        if (addr.contact) {
            let contact = distributorClone.querySelector('.contact');
            contact.href = addr.contact;
            contact.textContent = addr.contact;
            if (addr.contact_name) {
                contact.textContent = addr.contact_name;
            }
        }

        return distributorClone;
    }

    // Fügt Click-Handler hinzu
    addClickHandlers() {
        $('#vertriebspartner-content').on('click', '.continent-name-container', (event) => {
            const $continentNameContainer = $(event.currentTarget);
            const $continentDistributors = $continentNameContainer.closest('.continent').find('.continent-distributoren');

            // Merken, ob das angeklickte Element bereits geöffnet ist
            const isOpen = $continentNameContainer.hasClass('open');

            // Schließe alle Kontinente
            const closeAllContinents = () => {
                $('#vertriebspartner-content .continent-name-container').removeClass('open');
                $('#vertriebspartner-content .continent-distributoren').slideUp();
            };

            // Immer zuerst alle Kontinente schließen
            closeAllContinents();

            // Nur öffnen, wenn das aktuelle Element vorher NICHT geöffnet war
            if (!isOpen) {
                $continentNameContainer.addClass('open');
                $continentDistributors.slideDown();
            }
        });

    }
}